import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${() => css`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    margin-top: 30px;
    padding: 0.875rem 1rem;
    border-radius: 8px;
    border: 1px solid #f59e0b1a;
    background: #f59e0b1a;

    svg {
      color: #f59e0b;
      flex-shrink: 0;
      margin-top: 0.125rem;
    }
  `}
`

export const Text = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.5;
    color: ${theme.colors.secondary};
  `}
`
